import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NmDatatableSettings } from '../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup,FormControl, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'schools-report-page',
	templateUrl: './report.html',
	styleUrls: ['./report.css']
})
export class SchoolsReportPage {
	public modelName: string = 'school';
	public batchBtnStatus: boolean = true;
	public reloadTable: boolean = false;
	public schoolReported: boolean = false;
	public teacherReported: boolean = false;
	public schoolReportResult: string = '';
	public teacherReportResult: string = '';
	public sendPwdBtnStatus: boolean = true;
	

	public searchFields = {
		// basic information
		status: [''],
		schoolNature: [''],
		
	};
	public searchForm: FormGroup = this.formBuilder.group(this.searchFields);
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _searchForm: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public allFields  = this.searchFields;

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		
		// for(let col in this.allFields){
		// 	this.searchForm.addControl('col_'+col,new FormControl('col_'+col));
		// }

		this._searchForm.setForm(this.searchForm);
		this.onBeforeRendered();


		// for(let col in this.allFields){
		// 	this.searchForm.controls['col_'+col].setValue(true);
		// }

	}
	public onBeforeRendered() {


	}

	public onValidationFail(): void {
		this._searchForm.showErrors();
	};

	



	
	public onRunReport(report_type):void{
		if(!this.searchForm.valid){
			this.onValidationFail();
			return;
		}
		
		let queryStr = [];
		queryStr.push('export=1');
		queryStr.push('report_type='+report_type);
		
		// for(let col in this.allFields){
		// 	queryStr.push('col_'+col+'='+this.searchForm.value['col_'+col]);
		// }
		for(let field in this.searchFields){
			queryStr.push(field+'='+this.searchForm.value[field]);
		}
		let exporturl = '';
		if(queryStr.length > 0){
			exporturl = 'school/report?'+queryStr.join('&');
		}else{
			exporturl = 'school/report';
		}
		//console.log(this.datatableSetting);
		
		//this._setSearchUrl();
		if(report_type == 'school'){
			this.schoolReportResult = '';
			this.schoolReported = true;
		}else{
			this.teacherReportResult = '';
			this.teacherReported = true;
		}
		try {
			let promise;
			promise = this.api.sendApiRequest('get', exporturl).toPromise();
			

			promise
			.then(res => {
				//this.onAfterSubmit(true);
				if(report_type == 'school'){
					this.schoolReportResult = res._body;
					this.schoolReported = false;
				}else{
					this.teacherReportResult = res._body;
					this.teacherReported = false;
				}
				
				console.log(res);
			})
			.catch(err => {
				//this.onAfterSubmit(false);
				if(report_type == 'school'){
					this.schoolReported = false;
				}else{
					this.teacherReported = false;
				}
			});
		}
		catch(e) {
			console.error(e);
			if(report_type == 'school'){
				this.schoolReported = false;
			}else{
				this.teacherReported = false;
			}
		}

	}

	
}



// WEBPACK FOOTER //
// ./src/pages/schools/report/report.ts